import React from 'react';
import './BrandSlider.css';

// --- YENİ: LOGOLARI ASSETS KLASÖRÜNDEN İMPORT EDİYORUZ ---
// Kendi logo dosyalarının isimlerine göre burayı güncellemen GEREKİYOR.
// Örnek: import termikelLogo from '../../assets/logos/termikel.png';
import termikelLogo from '../../assets/termikel.jpeg';
import emincelikLogo from '../../assets/emincelik.jpeg';
import alveusLogo from '../../assets/alveus.jpeg';
import whiteDaisyLogo from '../../assets/white.jpeg';
import tekaLogo from '../../assets/teka.jpeg';
import ukinoxLogo from '../../assets/ukınox.png';
import estyLogo from '../../assets/esty.jpeg';
import frankeLogo from '../../assets/franke.jpeg';
import glGeneralLogo from '../../assets/gl.jpeg';
// --- LOGO IMPORTLARI SONU ---


// Marka listesi (logo yollarıyla birlikte)
const brands = [
  { name: 'Termikel', logo: termikelLogo },
  { name: 'Eminçelik', logo: emincelikLogo },
  { name: 'alveus', logo: alveusLogo },
  { name: 'White Daisy', logo: whiteDaisyLogo },
  { name: 'teka', logo: tekaLogo },
  { name: 'Ukinox', logo: ukinoxLogo },
  { name: 'esty', logo: estyLogo },
  { name: 'Franke', logo: frankeLogo },
  { name: 'gl general', logo: glGeneralLogo },
];


const BrandSlider = () => {
  return (
    <div className="brand-slider-container">
      <div className="brand-slider-track">
        
        {/* 1. KOPYA (Orijinal Liste) */}
        {brands.map((brand, index) => (
          <div className="brand-item" key={`brand-${index}`}>
            {/* --- Değişiklik: Tekrar RESİM kullanıyoruz --- */}
            <img 
              src={brand.logo} // <-- Burası artık import ettiğimiz logo değişkenini kullanıyor
              alt={brand.name} 
            />
          </div>
        ))}

        {/* 2. KOPYA (Kusursuz döngü için) */}
        {brands.map((brand, index) => (
          <div className="brand-item" key={`brand-dup-${index}`}>
            {/* --- Değişiklik: Tekrar RESİM kullanıyoruz --- */}
            <img 
              src={brand.logo} // <-- Burası artık import ettiğimiz logo değişkenini kullanıyor
              alt={brand.name} 
            />
          </div>
        ))}

      </div>
    </div>
  );
};

export default BrandSlider;